import React, { useEffect, useState } from 'react';
import { selectTranslations } from '../../../config/i18n/slice';
import { useSelector } from 'react-redux';
import { Divider } from 'semantic-ui-react';
import { BillingInfoIcon } from '../../../../Assets/Icons/svg';
import { Country, State } from 'country-state-city';

const BillingInfo = ({ targetedData }) => {
  const t = useSelector(selectTranslations);

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return 'en';
    }
  });

  let modeOptions = [
    {
      key: '1',
      value: 'cash',
      text: t.vendors.mode.cash,
    },
    {
      key: '2',
      value: 'credit card',
      text: t.vendors.mode.credit_card,
    },
    {
      key: '3',
      value: 'bank transfer',
      text: t.vendors.mode.bank,
    },
    {
      key: '4',
      value: 'procurement card',
      text: t.vendors.mode.procurement_card,
    },
    {
      key: '5',
      value: 'check',
      text: t.vendors.mode.check,
    },
    {
      key: '6',
      value: 'cliq',
      text: t.vendors.mode.cliq,
    },
  ];

  let accountTypeOption = [
    {
      key: '0',
      value: 'salaries account',
      text: t.vendors.account.salary,
    },
    {
      key: '1',
      value: 'basic bank account',
      text: t.vendors.account.basic,
    },
    {
      key: '2',
      value: 'time deposit account',
      text: t.vendors.account.time_deposit,
    },
    {
      key: '3',
      value: 'current account',
      text: t.vendors.account.current,
    },
    {
      key: '4',
      value: 'time deposit with prizes',
      text: t.vendors.account.time_deposit_price,
    },
    {
      key: '5',
      value: 'POS current account',
      text: t.vendors.account.pos,
    },
  ];

  const [fetching, setFetchLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    setFetchLoading(true);
    if (targetedData) {
      setData(targetedData);
      setFetchLoading(false);
    }
  }, [targetedData]);

  const mode = modeOptions.find(
    (status) => status.value == targetedData?.paymentDetails?.mode
  );

  const acc_type = accountTypeOption.find(
    (status) => status.value == targetedData?.paymentDetails?.accountType
  );

  return (
    <div className="preview-details-wrapper">
      
        <>
          <div className="intro">
            <div 
            // style={{ marginTop: '-8px' }} 
            className="billing-info  d-flex">
              <BillingInfoIcon />
              <p
              
                className={`font16 required-text mt-1 ${selectedLanguage == "en" ? "ml-2" : "mr-2"}`}
              >
                {t.customers.form.billing_information}
              </p>
            </div>
          </div>

          <div className="details-wrapper">
            <div className="d-flex align-items-center mt-7">
              <label className="workorder-intro-label vendor-label1">
                {t.customers.form.name}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.name ? targetedData?.name : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.locations.table.country}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.country
                  ? Country.getCountryByCode(targetedData?.country)?.name
                  : t.common.na}
              </p>
            </div>

          
            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
              {t.locations.table.city}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.city
                  ? State.getStateByCodeAndCountry(
                      targetedData?.city,
                      targetedData?.country
                    )?.name
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.customers.form.postal_code}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.postalCode
                  ? targetedData?.postalCode
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.customers.form.address}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.address ? targetedData?.address : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.customers.form.address_line_2}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.addressLine2
                  ? targetedData?.addressLine2
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.customers.form.address_line_3}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.addressLine3
                  ? targetedData?.addressLine3
                  : t.common.na}
               
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.customers.form.rate}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.rate
                  ? targetedData?.rate +
                    ' ' +
                    (targetedData?.currency ? targetedData?.currency : '')
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5 ">
              <label className="workorder-intro-label vendor-label1">
                {t.customers.form.currency}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.currency ? targetedData?.currency : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.vendors.form.pre_days}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.preProcessDays
                  ? targetedData?.preProcessDays
                  : t.common.na}
              </p>
            </div>

            <Divider className="mt-7" />

            <div className="billing-info  d-flex mt-7">
              <BillingInfoIcon />
              <p
              
                className={`font16 required-text mt-1 ${
                  selectedLanguage == 'en' ? 'ml-2' : 'mr-2'
                }`}
              >
                {t.vendors.form.payment_info}
              </p>
            </div>

            <div className="d-flex align-items-center mt-8">
              <label className="workorder-intro-label vendor-label1">
                {t.vendors.form.mode}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.paymentDetails?.mode ? mode?.text : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.vendors.form.bank}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.paymentDetails?.bank
                  ? targetedData?.paymentDetails?.bank
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.vendors.form.account}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.paymentDetails?.accountType
                  ? acc_type?.text
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.vendors.form.acc_no}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.paymentDetails?.accountNo
                  ? targetedData?.paymentDetails?.accountNo
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label vendor-label1">
                {t.vendors.form.IBAN}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.paymentDetails?.IBAN
                  ? targetedData?.paymentDetails?.IBAN
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label">
                {t.vendors.form.disbursement_currency}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.paymentDetails?.disbursementCurrency
                  ? targetedData?.paymentDetails?.disbursementCurrency
                  : t.common.na}
              </p>
            </div>

  
          </div>
        </>
  
    </div>
  );
};

export default BillingInfo;
